import React, { createContext, useContext, useCallback, useMemo } from 'react';
export const CustomNotificationContext = /*#__PURE__*/ createContext({
    notifications: [],
    removeNotification: ()=>null
});
CustomNotificationContext.displayName = 'CustomNotificationContext';
export const CustomNotificationProvider = ({ children, notifications, removeNotification, queueName })=>{
    const remove = useCallback((id)=>removeNotification(queueName, id), [
        queueName,
        removeNotification
    ]);
    const props = useMemo(()=>({
            notifications,
            removeNotification: remove
        }), [
        notifications,
        remove
    ]);
    return /*#__PURE__*/ React.createElement(CustomNotificationContext.Provider, {
        value: props
    }, children);
};
export function useCustomNotifications(notificationTypes) {
    const { notifications = [], removeNotification } = useContext(CustomNotificationContext);
    const filteredNotifications = notificationTypes ? notifications.filter((item)=>notificationTypes.includes(item.type)) : notifications;
    return {
        notifications: filteredNotifications,
        removeNotification
    };
}

//# sourceMappingURL=CustomNotificationContext.js.map